import { render, staticRenderFns } from "./NameDetail.vue?vue&type=template&id=ad4c7f12"
import script from "./NameDetail.vue?vue&type=script&lang=js"
export * from "./NameDetail.vue?vue&type=script&lang=js"
import style0 from "./NameDetail.vue?vue&type=style&index=0&id=ad4c7f12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports